import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    values: {
      sort: 'far fa-arrow-up',
      checkboxOn: 'far fa-check-square',
      checkboxOff: 'far fa-square',
      checkboxIndeterminate: 'far fa-square-minus',
      prev: 'far fa-chevron-left',
      next: 'far fa-chevron-right',
      info: 'far fa-info-circle',
      error: 'far fa-exclamation-triangle',
      success: 'far fa-check-circle',
      dropdown: 'far fa-chevron-down',
      clear: 'far fa-times-circle',
      cancel: 'far fa-times-circle',
      expand: 'far fa-chevron-down',
    },
  },
});
